import { css } from 'linaria';
import { theme } from '../../Theme';

export const headerIconStyle = css`
  height: 22px !important;
  cursor: pointer;
  color: ${theme.colors.layout.headerColor};
`;
